<ui-header (notify)="onNotify($event)" [menu]="isOpen"></ui-header>
<up-feature-sidebar-account (menu)="onNotify($event)" [openMenu]="isOpen"></up-feature-sidebar-account>
<main>
  <router-outlet></router-outlet>
</main>
<ui-footer></ui-footer>
